import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class SeedReplantAddReplantProductSliderModelService {
  public addProductSlider: BehaviorSubject<boolean>;
  public addSidenav: MatSidenav;
  private activeSliderValue: string;
  sliderCloseRqt: Subject<boolean>;
  addModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccount: number;
  public isCustomerPickup: boolean;
  public newItems: any;

  constructor() {
    this.addProductSlider = new BehaviorSubject(false);
    this.addModelData = new BehaviorSubject(EMPTY);
    this.sliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddSeedReplantProductSlider') {
      this.addProductSlider.next(true);
      this.addModelData.next(EMPTY);
      this.addSidenav.toggle();
    }
  }

  public setSideNav(sideNavObj: MatSidenav) {
    this.addSidenav = sideNavObj;
  }

  public close() {
    this.addModelData.next(EMPTY);
    this.addProductSlider.next(false);
    this.addSidenav.close();
  }

  public setData<T>(obj: T) {
    this.addModelData.next(obj);
  }

  public getNewItem() {
    return this.newItems;
  }

  public setNewItem(newItems) {
    this.newItems = [];
    this.newItems = newItems;
  }
}
